export default __webpack_public_path__ + "audio/voop.b63b6def.mp3";